// URS1 — URSSAF particulier states (twin of backend config/urssaf_status_rules.py).
export const URSSAF_STATE = Object.freeze({
  NOT_REGISTERED: 'NOT_REGISTERED',
  PENDING: 'PENDING',
  REGISTERED: 'REGISTERED',
  ACTION_REQUIRED: 'ACTION_REQUIRED',
});

// States whose badge opens the explanation.
export const URSSAF_EXPLAINED_STATES = Object.freeze([URSSAF_STATE.PENDING, URSSAF_STATE.ACTION_REQUIRED]);

// Foreground polling while FamilyDetail is open and the family is PENDING.
export const URSSAF_STATUS_POLL_MS = 120000;

// URS2: edit-form banner action, passed with the family save.
export const URSSAF_INTENT = Object.freeze({ REGISTER: 'register', RENEW: 'renew' });

// URS2: why no slot can be proposed (backend BLOCK_*).
export const PROPOSAL_BLOCK = Object.freeze({ TOO_OLD: 'older_than_30_days', NO_ROOM: 'no_room_before_now' });

// URS2: inbox « Réessayer » → /payments?family=<id>&urssaf_retry=<lesson ids>
export const URSSAF_RETRY_PARAM = Object.freeze({
  FAMILY: 'family', LESSONS: 'urssaf_retry', PAY_LESSONS: 'pay_lessons', REGISTER: 'urssaf_register',
});
// « Réessayer demain » origin: the payment demand, or the registration (URS2 balance phase).
export const RETRY_KIND = Object.freeze({ DEMAND: 'demand', REGISTRATION: 'registration' });
export const FAMILIES_PATH = '/families';
// Registration with an unpaid balance (backend BALANCE_MODE_*).
export const BALANCE_MODE = Object.freeze({
  NONE: 'none', PAY_OTHER_WAY: 'pay_other_way', CHOOSE: 'choose', PROPOSALS: 'proposals',
});
export const PAYMENTS_PATH = '/payments';

export const LESSONS_BEFORE_ACTIVATION = 'LESSONS_BEFORE_ACTIVATION';
